import { useQuery } from 'react-query';
import {
	getAllPublicSkills,
	getAllSellableSkills,
	getAllSellableSkillsForMentor,
	getAllSkills,
	getOnlySkills,
	getResumeSkills,
	getSkillById,
} from 'src/apis/skills';
import { FilterSkillQuery, GetAllSkillsAPIResponse, GetSkillByIdAPIResponse } from 'types';

export const useGetAllSkills = (
	filterData: FilterSkillQuery['filterQuery'],
	onComplete?: (data: GetAllSkillsAPIResponse) => void,
	handleError?: () => void,
) => {
	return useQuery({
		queryKey: ['getAllSkills'],
		queryFn: async () => (await getAllSkills(filterData)) as GetAllSkillsAPIResponse,
		staleTime: 60000,
		refetchOnMount: true,
		onSuccess(data) {
			onComplete && onComplete(data);
		},
		onError() {
			handleError && handleError();
		},
	});
};
export const useGetAllPublicSkills = (
	filterData: FilterSkillQuery['filterQuery'],
	onComplete?: (data: GetAllSkillsAPIResponse) => void,
	handleError?: () => void,
) => {
	return useQuery({
		queryKey: ['getAllPublicSkills'],
		queryFn: async () => (await getAllPublicSkills(filterData)) as GetAllSkillsAPIResponse,
		staleTime: 60000,
		refetchOnMount: true,
		onSuccess(data) {
			onComplete && onComplete(data);
		},
		onError() {
			handleError && handleError();
		},
	});
};
export const useGetAllSellableSkills = () => {
	return useQuery({
		queryKey: ['getAllSellableSkills'],
		queryFn: async () => (await getAllSellableSkills()) as GetAllSkillsAPIResponse,
		staleTime: 60000,
		refetchOnMount: true,
	});
};

export const useGetAllSellableSkillsForMentor = () => {
	return useQuery({
		queryKey: ['getAllSellableSkillsForMentor'],
		queryFn: async () => (await getAllSellableSkillsForMentor()) as GetAllSkillsAPIResponse,
		staleTime: 60000,
		refetchOnMount: true,
	});
};

export const useGetOnlySkills = () => {
	return useQuery({
		queryKey: ['getOnlySkills'],
		queryFn: async () => (await getOnlySkills()) as GetAllSkillsAPIResponse,
		staleTime: 60000,
		refetchOnMount: true,
	});
};
export const useGetAllResumeSkills = () => {
	return useQuery({
		queryKey: ['getResumeSkills'],
		queryFn: async () => (await getResumeSkills()) as GetAllSkillsAPIResponse,
		staleTime: 60000,
		refetchOnMount: true,
	});
};
export const useGetSkillById = (id?: string) => {
	return useQuery({
		queryKey: ['getSkillById', id],
		queryFn: async () => (await getSkillById(id ?? '')) as GetSkillByIdAPIResponse,
		staleTime: 60000,
		enabled: !!id,
		refetchOnMount: true,
	});
};
